"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/esnext.map.delete-all.js";
import "core-js/modules/esnext.map.every.js";
import "core-js/modules/esnext.map.filter.js";
import "core-js/modules/esnext.map.find.js";
import "core-js/modules/esnext.map.find-key.js";
import "core-js/modules/esnext.map.includes.js";
import "core-js/modules/esnext.map.key-of.js";
import "core-js/modules/esnext.map.map-keys.js";
import "core-js/modules/esnext.map.map-values.js";
import "core-js/modules/esnext.map.merge.js";
import "core-js/modules/esnext.map.reduce.js";
import "core-js/modules/esnext.map.some.js";
import "core-js/modules/esnext.map.update.js";
import "core-js/modules/web.dom-collections.iterator.js";
export let CacheManager = /*#__PURE__*/function () {
  function CacheManager(options = {}) {
    _defineProperty(this, "memoryCache", new Map());
    _defineProperty(this, "accessTimes", new Map());
    this.maxMemoryCacheSize = options.maxMemoryCacheSize || 100;
  }

  /**
   * Get a cached translation from memory only
   */
  var _proto = CacheManager.prototype;
  _proto.get = async function get(key) {
    const memoryCached = this.memoryCache.get(key);
    if (memoryCached) {
      // Update access time for LRU tracking
      this.accessTimes.set(key, Date.now());
      return memoryCached;
    }
    return null;
  }

  /**
   * Set a cached translation in memory
   */;
  _proto.set = async function set(key, data) {
    this.memoryCache.set(key, data);
    // Track access time for LRU
    this.accessTimes.set(key, Date.now());
    this.enforceMemoryCacheSize();
  }

  /**
   * Store a manifest in memory cache
   * Note: We don't persist manifests since they change with deployments
   */;
  _proto.setManifest = async function setManifest(locale, manifest) {
    // Store in memory with a special key prefix
    const manifestKey = `__manifest_${locale}`;
    this.memoryCache.set(manifestKey, {
      data: manifest,
      timestamp: Date.now()
    });
  }

  /**
   * Get a cached manifest from memory
   */;
  _proto.getManifest = async function getManifest(locale) {
    const manifestKey = `__manifest_${locale}`;
    const cached = this.memoryCache.get(manifestKey);
    return (cached === null || cached === void 0 ? void 0 : cached.data) || null;
  }

  /**
   * Enforce memory cache size limit using LRU (Least Recently Used) eviction
   */;
  _proto.enforceMemoryCacheSize = function enforceMemoryCacheSize() {
    if (this.memoryCache.size > this.maxMemoryCacheSize) {
      // Find least recently used entry
      let oldestKey;
      let oldestTime = Number.POSITIVE_INFINITY;
      for (const [key, time] of this.accessTimes) {
        if (time < oldestTime) {
          oldestTime = time;
          oldestKey = key;
        }
      }

      // Remove least recently used entry
      if (oldestKey) {
        this.memoryCache.delete(oldestKey);
        this.accessTimes.delete(oldestKey);
      }
    }
  }

  /**
   * Clear all cache entries from memory
   */;
  _proto.clearAll = function clearAll() {
    this.memoryCache.clear();
    this.accessTimes.clear();
  };
  return CacheManager;
}();